import { useSchematicBuilderContext } from "../../SchematicBuilderContext";
import { preventDrag } from "../../util/preventDrag";

export function ChildRemove() {
  const { removeSchematic } = useSchematicBuilderContext();
  return (
    <button
      className="builder-icon-button builder-child-remove"
      type="button"
      title="Remove"
      onClick={removeSchematic}
      {...preventDrag}
    >
      ×
    </button>
  );
}
